/** Nexus dashboard permissions (distinct strings; shared Mongo `roles` collection). */
export enum NexusPermission {
  UserManage = 'Nexus.UserManage',
  UsersImpersonate = 'Nexus.UsersImpersonate',
  UsersChangePassword = 'Nexus.UsersChangePassword',

  ClientView = 'Nexus.Client.View',
  ClientStats = 'Nexus.Client.Stats',
  ClientKillSwitch = 'Nexus.Client.KillSwitch',
  ClientManage = 'Nexus.Client.Manage',

  Scheduling = 'Nexus.Scheduling',
  RoutePlanning = 'Nexus.RoutePlanning',

  WhitelistManage = 'Nexus.Whitelist.Manage',
  IntrospectionView = 'Nexus.Introspection.View',
  PartnerSchedulingImport = 'Nexus.PartnerSchedulingImport',
  PartnerSchedulingClientToggle = 'Nexus.PartnerSchedulingClientToggle',
  ArticleGeneration = 'Nexus.ArticleGeneration',
}

export const NexusRoleNames = {
  NEXUS_CLIENT_EDITOR: 'Nexus Editor',
  NEXUS_CLIENT_VIEWER: 'Nexus Viewer',
} as const;

/** Permissions that may be scoped to specific Client IDs in RoleAssignment.scope. */
export const CLIENT_SCOPABLE_PERMISSIONS = [
  NexusPermission.ClientView,
  NexusPermission.ClientStats,
  NexusPermission.ClientKillSwitch,
  NexusPermission.Scheduling,
  NexusPermission.RoutePlanning,
] as const;

/** Permissions scoped to partner-scheduling `clientKey`s (workbook identity, not Nexus Client). */
export const PARTNER_CLIENT_SCOPABLE_PERMISSIONS = [NexusPermission.PartnerSchedulingClientToggle] as const;
